import { scrollToHash } from '@blissbook/ui/util/scroll'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export function ScrollToHash({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const prevLocationRef = useRef(location)

  useEffect(() => {
    const prevLocation = prevLocationRef.current
    if (location.pathname !== prevLocation.pathname) {
      window.scrollTo(0, 0)
      scrollToHash(location.hash)
    } else if (location.hash !== prevLocation.hash) {
      scrollToHash(location.hash, { delay: 250 })
    }

    prevLocationRef.current = location
  }, [location])

  return <>{children}</>
}
